/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define([], function() {
    'use strict';
    var defaultStylesIndex = 0,
        defaultLayersIndex = 0;

    function getMap(type) {
        switch (type) {
        case 'vectorTrafficFlow':
            return {
                style: ['vectorTrafficFlow'],
                layer: ['absolute', 'relative', 'relative-delay']
            };
        case 'vectorTrafficIncidents':
            return {
                style: ['vectorTrafficIncidents'],
                layer: ['s1', 's2', 's3', 'night']
            };
        case 'vector':
        default: {
            return {
                style: ['main', 'night'],
                layer: ['basic', 'hybrid', 'labels']
            };
        }
        }
    }

    function validateStyleOrLayer(map, options, key) {
        if (!options || !options[key]) {
            return false;
        }
        return map[key].indexOf(options[key]) !== -1;
    }

    function copyFromOptionsToTheme(map, options, theme, key) {
        if (validateStyleOrLayer(map, options, key)) {
            theme[key] = options[key];
        }
    }

    return {
        getTheme: function(optionsHierarchyArray, type) {
            var i,
                map = getMap(type),
                options,
                theme = {
                    style: map.style[defaultStylesIndex],
                    layer: map.layer[defaultLayersIndex]
                },
                length = optionsHierarchyArray ? optionsHierarchyArray.length : 0;
            for (i = 0; i < length; ++i) {
                options = optionsHierarchyArray[i];
                copyFromOptionsToTheme(map, options, theme, 'style');
                copyFromOptionsToTheme(map, options, theme, 'layer');
            }
            return theme;
        }
    };
});



// WEBPACK FOOTER //
// ./display/layers/mapTheme.js